<template>
  <div id="TicketsBlock" class="TicketsBlock" :class="{ inHero: inHero }">
    <h3 class="new-h3 TicketsBlock__heading">{{ translations.tickets }}</h3>

    <div v-if="event">
      <div class="TicketsBlock__subheading">
        {{ inHero ? event.ticketWidgetSubHeading : event.price }}
      </div>

      <ul v-if="filteredEventDates.length" class="TicketsBlock__list">
        <li
          class="TicketsBlock__date"
          v-for="date in filteredEventDates.slice(0, 3)"
          :key="date.id"
        >
          <EventDate :details="date" :inHero="inHero" />
        </li>
      </ul>
      <div v-else style="margin-bottom: 2rem">
        Inga datum att boka för tillfället
      </div>

      <div class="TicketsBlock__actions">
        <a
          :href="event.fullPath"
          :data-event-nid="eventNid"
          :class="{ 'event-modal': disableModal }"
          class="button button--notheme button--book-large button--secondary TicketsBlock__button"
          >{{ inHero ? "Mer info" : "Läs mer" }}</a
        >
        <a
          :href="event.purchaseUrl"
          class="button button--book-large TicketsBlock__button"
          :class="
            inHero
              ? 'book-' + event.tid + '-inHero--view-all-dates'
              : 'book-' + event.tid + '-inModal--view-all-dates'
          "
        >
          Se alla datum
        </a>
      </div>
    </div>

    <div v-else class="TicketsBlock__loading">
      <SkeletonBox width="100%" height="32px" margin="1rem" />
      <SkeletonBox width="100%" height="32px" margin="1rem" />
      <SkeletonBox width="100%" height="32px" margin="1.5rem" />
      <div style="display: flex; justify-content: space-between">
        <SkeletonBox width="49%" height="50px" />
        <SkeletonBox width="49%" height="50px" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventDate from "./components/EventDate.vue";
import SkeletonBox from "../../vue_components/SkeletonBox/SkeletonBox.vue";

export default {
  name: "TicketBlock",
  components: { SkeletonBox, EventDate },
  props: {
    eventNid: {
      type: [String, null],
      required: true,
    },
    inHero: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      translations: {
        tickets: Drupal.t("Tickets"),
        hideSoldOutDates: Drupal.t("Hide sold out dates"),
        loadingTicketInfo: Drupal.t("Loading ticket information"),
        noIdMessage: Drupal.t(
          "No Klara event id is set, this block needs an ID to work"
        ),
        noItemsMessage: Drupal.t("No dates are currently available"),
      },
      hideSoldOut: false,
    };
  },
  created() {
    if (this.eventNid) {
      !this.eventData[this.eventNid] && this.fetchEventData(this.eventNid);
    }
  },
  methods: {
    ...mapActions(["fetchEventData"]),
  },
  computed: {
    ...mapGetters({
      eventData: "getEventData",
      loadingTickets: "getLoadingTicketsState",
    }),
    event() {
      return this.eventData[this.eventNid];
    },
    filteredEventDates() {
      return this.event.dates.filter((item) => {
        // Filter out items that should not be visible in tickets block.
        return item.salesStatus.forSale;
      });
    },
    disableModal() {
      // Make sure editor has not turned of modal functionality for the event.
      if (this.inHero && !this.event.disableModal) {
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.TicketsBlock {
  background: white;
  padding: 1rem 2rem;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 4px 32px rgba(0, 0, 0, 0.28);

  @include breakpoint($toolbar) {
    padding: 2rem 2.5rem;
    min-width: 380px;
  }
}

.TicketsBlock__heading {
  display: none;
  margin-bottom: 2px;
  text-transform: uppercase;

  @include breakpoint($toolbar) {
    display: block;
  }
}

.TicketsBlock__subheading {
  display: none;
  margin-bottom: 1rem;
  color: $grey;
  font-size: 12px;
  text-transform: uppercase;

  @include breakpoint($toolbar) {
    display: block;
  }
}

.TicketsBlock__list {
  padding: 0;
  margin: 0 0 2rem;
  list-style: none;

  @include breakpoint($toolbar) {
    margin: 2rem 0;
  }
}

.TicketsBlock__date {
  border-top: 1px solid $grey-light;
  padding: 1rem 0 0;
  margin-bottom: 1.2rem;

  &:first-child {
    border: none;
  }

  .inHero & {
    &:nth-child(3) {
      display: none;
    }
    @include breakpoint($toolbar) {
      &:nth-child(3) {
        display: block;
      }
    }
  }
}

.TicketsBlock__actions {
  display: flex;
  justify-content: space-between;
}

a.TicketsBlock__button {
  display: inline-block;
  margin-left: 1rem;
  width: 100%;
}

.TicketsBlock__loading {
  padding-top: 18px;

  @include breakpoint($toolbar) {
    padding-top: 54px;
  }
  .inHero & {
    > .SkeletonBox {
      &:nth-child(1) {
        display: none;
      }

      @include breakpoint($toolbar) {
        &:nth-child(1) {
          display: block;
        }
      }
    }
  }
}
</style>
